import React from 'react';

import ReactDOM from 'react-dom/client';

import { Apps } from './Apps';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Apps />);
